import { hasAttributes } from "utils/objects";
import ApiFactory from "api/ApiFactory";

const BASE_URL = "/calendar/v3";

const CalendarAPI = (token) => {
    const API = ApiFactory("Google", { token });

    return {
        getColorsAsync: async () => {
            return API.getAllAsync({ url: `${BASE_URL}/colors` });
        },
        getCalendarsAsync: async () => {
            return API.getAllAsync({ url: `${BASE_URL}/users/me/calendarList`, normalizer: (data) => data.items });
        },
        getEventsAsync: async (calendarId, filters, timeMin, timeMax) => {
            let customFilters = {
                orderBy: "startTime",
                singleEvents: true,
            };
            if (timeMin) {
                customFilters = { ...customFilters, timeMin };
            }
            if (timeMax) {
                customFilters = { ...customFilters, timeMax };
            }
            if (hasAttributes(filters)) {
                customFilters = Object.keys(filters).reduce(
                    (map, key) => ({ ...map, sharedExtendedProperty: `${key}=${filters[key]}` }),
                    customFilters
                );
            }
            return API.getAllAsync({
                url: `${BASE_URL}/calendars/${encodeURIComponent(calendarId)}/events`,
                data: customFilters,
                normalizer: (data) => (data.items || []).map((item) => ({ ...item, calendarId, accessRole: data.accessRole })),
            });
        },
        getGuestEventsAsync: async (email, timeMin, timeMax) => {
            let customFilters = {
                orderBy: "startTime",
                singleEvents: true,
            };
            if (timeMin) {
                customFilters = { ...customFilters, timeMin };
            }
            if (timeMax) {
                customFilters = { ...customFilters, timeMax };
            }
            return API.getAllAsync({
                url: `${BASE_URL}/calendars/${encodeURIComponent(email)}/events`,
                data: customFilters,
                normalizer: (data) => {
                    const events = (data.items || []).map((item) => ({ ...item, calendarId: email, accessRole: data.accessRole }));
                    return { email, events };
                },
            });
        },
        getEventAsync: async (calendarId, eventId) => {
            return API.getAllAsync({ url: `${BASE_URL}/calendars/${encodeURIComponent(calendarId)}/events/${eventId}` });
        },
        addEventAsync: async (calendarId, event) => {
            return API.addAsync({
                url: `${BASE_URL}/calendars/${encodeURIComponent(calendarId)}/events`,
                data: event,
                config: {
                    params: {
                        sendUpdates: "all",
                    },
                },
            });
        },
        updateEventAsync: async (calendarId, eventId, event) => {
            return API.updateAsync({
                url: `${BASE_URL}/calendars/${encodeURIComponent(calendarId)}/events/${eventId}`,
                data: event,
                config: {
                    params: {
                        sendUpdates: "all",
                    },
                },
            });
        },
        deleteEventAsync: async (calendarId, eventId) => {
            return API.deleteAllAsync({
                url: `${BASE_URL}/calendars/${encodeURIComponent(calendarId)}/events/${eventId}`,
                config: {
                    params: {
                        sendUpdates: "all",
                    },
                },
            });
        },
    };
};

export default CalendarAPI;
